import fenToYuan from '@/utils/fen-to-yuan'

/**
 * @author: yami
 * @description：format-amount 金额转分，并输出格式化后的结果
 */
export function fenToYanAndFormat (num) {
  return formatAmount(fenToYuan(num))
}

/**
 * @author: yami
 * @description：format-amount 格式化金额
 */
export function formatAmount (num) {
  // 不展示小数位
  return Math.floor(Number(num)).toLocaleString('id-ID', { maximumFractionDigits: 0 })
}
